/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import dykBackgroungImg from "../../../assets/dyk-banner.png";
import progressBackgroungImg from "../../../assets/circluar-bg.png";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import BottomSection from "../../shared-ui/bottom-section";
import AnimatedProgressProvider from "../../shared-ui/animated-progress";
import { easeQuadInOut } from "d3-ease";
import _ from "lodash";
import ReactHtmlParser from "react-html-parser";
import { getGroupedProductsData } from "../../../utils/productsData";
import { getGroupedTipsData } from "../../../utils/tipsData";
import { getGroupedFoodsData } from "../../../utils/foodsData";
import { getGroupedReasonsData } from "../../../utils/reasonData";
import { asyncLocalStorage } from "../../../utils/asyncStorage";
import { setAccessToken } from "../../../services/commerceServices/accessToken";
import { withOktaAuth } from "@okta/okta-react";
import { uniqueUserId } from "../../../utils/generateUniqueId";
import { suggesticCalls } from "../../../services/suggesticServices";
import { setGuestSaveResultTime } from "../../../utils/handleExpiryTime";
import {
  cartMergingCall,
  getOrCreateCart,
} from "../../../services/commerceServices/cartServices";
import { convertIntoTitleCase } from "../../../utils/validation";

// Interface for ConnectionMoment Props
interface ConnectionMomentProps {
  connectionMomentType: string;
  connectionMomentImage: any;
  connectionMomentSubtitle: any;
  connectionMomentTitle: any;
  timer: any;
  needStateCm: any;
  dependentConnectionMoment: any;
  cmTitle: any;
  t?: any;
  handleSuccessfulContinue?: any;
  handleChildContinue?: any;
  isAuthenticated?: any;
  userName?: any;
  contentTypeId?: string;
}
// Interface for ConnectionMoment State
interface ConnectionMomentState {
  usersName: any;
  isEmptyName: boolean;
  myResultsEnable: boolean;
  cmImage: any;
  title: any;
  cmTitleState: any;
  subTitle: any;
  error: any;
  combinedData: any;
  tips: boolean;
  products: boolean;
  foods: boolean;
  reasons: boolean;
  greetingTitle: string;
  needStatesNames: string;
}
var x: any;
/**
 * Connection Moment component
 *
 * @namespace ConnectionMoment
 */
class ConnectionMoment extends React.Component<
  any,
  //ConnectionMomentProps,
  ConnectionMomentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      usersName: "",
      isEmptyName: false,
      myResultsEnable: false,
      cmImage: "",
      title: "",
      cmTitleState: "",
      subTitle: [],
      error: {},
      combinedData: {},
      tips: false,
      foods: false,
      products: false,
      reasons: false,
      greetingTitle: "",
      needStatesNames: "",
    };
  }

  componentDidMount = async () => {
    this.props.handleChildContinue(this.handleError);
    const {
      connectionMomentType,
      dependentConnectionMoment,
      needStateCm,
      timer,
      cmTitle,
      userName,
      contentTypeId,
      isAuthenticated,
      connectionMomentTitle,
    } = this.props;
    let greetingTitle = "";
    if (contentTypeId === "ms_indcm_welcome") {
      greetingTitle = !isAuthenticated
        ? connectionMomentTitle[0]?.replace(
            "$Name",
            convertIntoTitleCase(userName)
          )
        : connectionMomentTitle[1]?.replace(
            "$Name",
            convertIntoTitleCase(userName)
          );
    } else {
      greetingTitle = "";
    }
    this.setState({
      cmTitleState: cmTitle,
      usersName: userName,
      greetingTitle: greetingTitle,
    });
    if (connectionMomentType && connectionMomentType === "cm_dyk") {
      let useResponse: any = localStorage.getObj("user-response");
      let needStateRanks: any = [];
      _.map(useResponse, function (eachUserData) {
        if (eachUserData?.contentTypeId === "ms_interested_wellness_area" || eachUserData?.contentTypeId === "ms_short_needstate_ques") {
          needStateRanks = eachUserData.recoValues;
        }
      });
      let needStates: any =
        needStateRanks && needStateRanks[0]?.replace("-", "_");

      this.setState({
        cmImage: needStateCm[needStates]?.cm_image?.url,
        title: needStateCm[needStates]?.cm_title,
        subTitle: needStateCm[needStates]?.cm_subtitle,
      });
    }
    if (connectionMomentType && connectionMomentType === "cm_result") {
      let useResponse: any = localStorage.getObj("user-response");
      let needStateRanks: any = [];
      _.map(useResponse, function (eachUserData) {
        if (eachUserData?.contentTypeId === "ms_interested_wellness_area" || eachUserData?.contentTypeId === "ms_short_needstate_ques") {
          needStateRanks = eachUserData.values;
        }
      });
      this.setState({
        needStatesNames: needStateRanks.join(", "),
      });
      await setAccessToken(this.props.oktaAuth);
      // await cartMergingCall();

      await getOrCreateCart().then(async () => {
        if (
          localStorage.getItem("cartId") &&
          localStorage.getItem("okta-token-storage")
        ) {
          await cartMergingCall();
        }
      });
      if (!localStorage.getItem("sg-user")) {
        uniqueUserId();
      }
      await suggesticCalls();

      let resp = localStorage.getObj("reco-result");

      const dataResponse = _.cloneDeep(
        resp?.data?.getRecommendation || resp?.data?.getRecommendationById
      );
      const self = this;
      let groupedProductsData = getGroupedProductsData(
        dataResponse,
        function (resp: any) {
          self.setState(
            {
              combinedData: {
                ...self.state.combinedData,
                products: resp,
              },
            },
            () => {
              self.setState({ products: true });
            }
          );
        }
      );

      let groupedTipsData = getGroupedTipsData(
        dataResponse,
        function (resp: any) {
          self.setState(
            {
              combinedData: {
                ...self.state.combinedData,
                tips: resp,
              },
            },
            () => {
              self.setState({ tips: true });
            }
          );
        }
      );

      let groupedFoodsData = getGroupedFoodsData(
        dataResponse,
        function (resp: any) {
          self.setState(
            {
              combinedData: {
                ...self.state.combinedData,
                foods: resp,
              },
            },
            () => {
              self.setState({ foods: true });
            }
          );
        }
      );
      let groupedReasonsData = getGroupedReasonsData(dataResponse);
      groupedReasonsData.then((response) => {
        this.setState(
          {
            combinedData: { ...this.state.combinedData, reasons: response },
          },
          () => {
            self.setState({ reasons: true });
          }
        );
      });

      // setTimeout(() => {
      //   this.setState({
      //     myResultsEnable: true,
      //   });
      // }, timer);

      // setTimeout(() => {
      //   this.setState({
      //     myResultsEnable: true,
      //   });
      // }, timer);
    } else if (connectionMomentType && connectionMomentType !== "cm_dyk") {
      clearTimeout(x);
      x = setTimeout(() => {
        this.props.handleSuccessfulContinue();
      }, timer);
    }
  };

  redirectToResults = () => {
    localStorage.setItem("isAssessmentDone", "true");
    //sets save result popup time for guest user
    if (!localStorage.getItem("okta-token-storage")) {
      setGuestSaveResultTime();
    }

    this.props.history.push("/results", {
      data: this.state.combinedData,
    });

    //this.props.handleSuccessfulContinue();
  };

  // componentWillReceiveProps(props: any) {
  //   //getContentFormComponenet function is called here
  //   if (props && props.i18n.language) {
  //     console.log("connection moment lang change");
  //     if (this.state.myResultsEnable === true) {
  //       this.setState({ myResultsEnable: false, combinedData: [] });
  //     }
  //   }
  // }

  componentDidUpdate = async () => {
    const {
      connectionMomentType,
      dependentConnectionMoment,
      needStateCm,
      timer,
      cmTitle,
    } = this.props;
    if (cmTitle !== this.state.cmTitleState) {
      // if (this.state.myResultsEnable === true) {
      //   this.setState({
      //     myResultsEnable: false,
      //   });
      // }

      if (connectionMomentType && connectionMomentType === "cm_result") {
        let useResponse: any = localStorage.getObj("user-response");
        let needStateRanks: any = [];
        _.map(useResponse, function (eachUserData) {
          if (eachUserData?.contentTypeId === "ms_interested_wellness_area" || eachUserData?.contentTypeId === "ms_short_needstate_ques") {
            needStateRanks = eachUserData.values;
          }
        });
        if (needStateRanks?.join(", ") !== this.state.needStatesNames) {
          this.setState({
            needStatesNames: needStateRanks.join(", "),
          });
        }
        if (this.state.myResultsEnable === true) {
          this.setState({
            myResultsEnable: false,
            tips: false,
            foods: false,
            products: false,
            reasons: false,
          });
        }

        await setAccessToken(this.props.oktaAuth);
        await getOrCreateCart().then(async () => {
          if (
            localStorage.getItem("cartId") &&
            localStorage.getItem("okta-token-storage")
          ) {
            await cartMergingCall();
          }
        });

        if (!localStorage.getItem("sg-user")) {
          uniqueUserId();
        }
        await suggesticCalls();
        // this.setState({
        //   needStatesNames: needStateRanks.join(", "),
        // });

        const resp = await localStorage.getObj("reco-result");

        const dataResponse = _.cloneDeep(
          resp?.data?.getRecommendation || resp?.data?.getRecommendationById
        );
        var self = this;
        let groupedProductsData = getGroupedProductsData(
          dataResponse,
          function (resp: any) {
            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  products: resp,
                },
              },
              () => {
                self.setState({ products: true });
              }
            );
          }
        );

        let groupedTipsData = getGroupedTipsData(
          dataResponse,
          function (resp: any) {
            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  tips: resp,
                },
              },
              () => {
                self.setState({ tips: true });
              }
            );
          }
        );

        let groupedFoodsData = getGroupedFoodsData(
          dataResponse,
          function (resp: any) {
            self.setState(
              {
                combinedData: {
                  ...self.state.combinedData,
                  foods: resp,
                },
              },
              () => {
                self.setState({ foods: true });
              }
            );
          }
        );
        let groupedReasonsData = getGroupedReasonsData(dataResponse);
        groupedReasonsData.then((response) => {
          this.setState(
            {
              combinedData: { ...this.state.combinedData, reasons: response },
            },
            () => {
              self.setState({ reasons: true });
            }
          );
        });
      } else if (connectionMomentType && connectionMomentType === "cm_dyk") {
        let useResponse: any = localStorage.getObj("user-response");
        let needStateRanks: any = [];
        _.map(useResponse, function (eachUserData) {
          if (eachUserData?.contentTypeId === "ms_interested_wellness_area" || eachUserData?.contentTypeId === "ms_short_needstate_ques") {
            needStateRanks = eachUserData.recoValues;
          }
        });
        let needStates: any =
          needStateRanks && needStateRanks[0]?.replace("-", "_");
        this.setState({
          cmImage: needStateCm[needStates]?.cm_image?.url,
          title: needStateCm[needStates]?.cm_title,
          subTitle: needStateCm[needStates]?.cm_subtitle,
        });
      }
      // else if (connectionMomentType && connectionMomentType === "cm_result") {
      //   let useResponse: any = localStorage.getObj("user-response");
      //   let needStateRanks: any = [];
      //   _.map(useResponse, function (eachUserData) {
      //     if (eachUserData?.contentTypeId === "ms_interested_wellness_area") {
      //       needStateRanks = eachUserData.recoValues;
      //     }
      //   });
      //   this.setState({
      //     needStatesNames: needStateRanks.join(", ")
      //   });
      //   setTimeout(() => {
      //     this.setState({
      //       myResultsEnable: true,
      //     });
      //   }, timer);
      // }
      else {
        clearTimeout(x);
        x = setTimeout(() => {
          this.props.handleSuccessfulContinue();
        }, timer);
      }
      this.setState({
        cmTitleState: cmTitle,
      });
    }
  };

  /**
   *  Handle back on DYK screen
   */
  handleError = () => {
    const { connectionMomentType } = this.props;
    if (connectionMomentType && connectionMomentType === "cm_dyk") {
      this.props.handleSuccessfulContinue();
    }
  };

  render() {
    if (
      this.state.tips &&
      this.state.products &&
      this.state.foods &&
      this.state.reasons
    ) {
      localStorage.setObj("results", this.state.combinedData);
      const appLanguage: any = sessionStorage.getItem("languageTypeOfApp");
      if (sessionStorage.getItem("languageTypeOfApp") === null) {
        localStorage.setItem("results-language", "en-us");
      } else {
        localStorage.setItem("results-language", appLanguage);
      }

      if (this.state.myResultsEnable === false) {
        this.setState({
          myResultsEnable: true,
        });
      }
    }
    //else {
    //   if (this.state.myResultsEnable === true) {
    //     this.setState({
    //       myResultsEnable: false,
    //     });
    //   }
    // }

    // const { myResultsEnable, cmImage, title, subTitle } = this.state;
    // const {
    //   connectionMomentType,
    //   connectionMomentImage,
    //   connectionMomentSubtitle,
    //   connectionMomentTitle,
    //   timer,
    //   needStateCm,
    // } = this.props;
    // const cmTitle: any =
    //   connectionMomentType && connectionMomentType === "cm_dyk"
    //     ? title && title[0]
    //     : connectionMomentTitle && connectionMomentTitle[0];
    // const cmSubTitle: Array<string> =
    //   connectionMomentType && connectionMomentType === "cm_dyk"
    //     ? subTitle
    //     : connectionMomentSubtitle;
    const {
      myResultsEnable,
      cmImage,
      title,
      subTitle,
      usersName,
      needStatesNames,
    } = this.state;
    const {
      connectionMomentType,
      connectionMomentImage,
      connectionMomentSubtitle,
      connectionMomentTitle,
      timer,
      needStateCm,
      isAuthenticated,
      userName,
      contentTypeId,
    } = this.props;
    const cmTitle: any =
      connectionMomentType && connectionMomentType === "cm_dyk"
        ? title && title[0]
        : connectionMomentTitle && connectionMomentTitle[0];
    let cmSubTitle: Array<string> =
      connectionMomentType && connectionMomentType === "cm_dyk"
        ? subTitle
        : connectionMomentSubtitle;

    return (
      <>
        <div
          className={
            connectionMomentType && connectionMomentType === "cm_dyk"
              ? "connection-moment-container top-align"
              : "connection-moment-container"
          }
        >
          <div className="cm-wrapper">
            {connectionMomentImage &&
            connectionMomentImage.url &&
            connectionMomentType !== "cm_dyk" ? (
              <div className="circular-progress-wrapper">
                <AnimatedProgressProvider
                  valueStart={0}
                  valueEnd={connectionMomentType && connectionMomentType === "cm_result"? (this.state.myResultsEnable?100:90):100}
                  duration={
                    connectionMomentType && connectionMomentType === "cm_result"
                      ? this.state.myResultsEnable ? 1:(timer && timer / 1000)
                      : timer && timer / 1000
                  }
                  easingFunction={easeQuadInOut}
                  // repeat
                >
                  {(value: number) => {
                    return (
                      <CircularProgressbarWithChildren
                        value={value}
                        strokeWidth={4}
                        styles={buildStyles({
                          trailColor: "#E6F1ED",
                          pathColor: "#66A98F",
                          pathTransition: "none",
                        })}
                      >
                        <img
                          className="circle-img"
                          src={connectionMomentImage?.url}
                          alt="Background"
                        />
                      </CircularProgressbarWithChildren>
                    );
                  }}
                </AnimatedProgressProvider>
              </div>
            ) : null}
            {/* This only for Do you know connection moment Start */}
            {connectionMomentType && connectionMomentType === "cm_dyk" ? (
              <div className="dyk-banner-wrapper">
                <img src={cmImage} className="icon dyk-banner" alt="banner" />
                <div className="overlay"></div>
                <div className="dyk-label align-middle">
                  {this.props.t("common.dyk_text")}
                </div>
              </div>
            ) : null}
            {/* This only for Do you know connection moment Ends */}
            <div className="middle-area">
              <div className="title">
                {this.state.greetingTitle
                  ? this.state.greetingTitle
                  : cmTitle
                  ? cmTitle
                  : ""}
              </div>
              {cmSubTitle
                ? cmSubTitle.map((indexer: any, itemIndex: any) => (
                    <div className="sub-title" key={itemIndex}>
                      {indexer.includes("$NeedStateRank")
                        ? ReactHtmlParser(
                            indexer.replace(
                              "$NeedStateRank",
                              `<span style="font-weight:bold"> ${needStatesNames}</span>`
                            )
                          )
                        : indexer}
                    </div>
                  ))
                : null}
            </div>
          </div>
          {/* This Bottom Section only for results type connection moment */}
          {connectionMomentType && connectionMomentType === "cm_result" ? (
            <BottomSection
              {...this.props}
              id={"myResults"}
              btnName={this.props.t("common.my_results")}
              handleButtonClick={this.redirectToResults}
              btnClassName={
                myResultsEnable
                  ? "app-btn btn-icon"
                  : "app-btn btn-icon disagree"
              }
            />
          ) : null}
        </div>
      </>
    );
  }
}

export default withOktaAuth(ConnectionMoment);
